/* eslint-disable no-unused-vars */
import StepperComponent from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import * as S from "./styles";

import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState,
} from "react";
import { StepContent } from "@material-ui/core";
import { lightTheme } from "styles/themes/light";

import { useWindowSize } from "react-use";
import { IF } from "components/IF";

export interface StepProps {
  title: string;
  content: ReactNode;
}

interface StepperProps {
  steps: StepProps[];
}

interface StepperContextProps {
  goToNextStep: () => void;
  goToPreviousStep: () => void;
}

const StepperContext = createContext({} as StepperContextProps);

const Stepper = ({ steps }: StepperProps) => {
  const { width } = useWindowSize();
  const [activeStep, setActiveStep] = useState(0);
  const breakpointMedium = Number(
    lightTheme.breakpoints.medium.replace("px", "")
  );

  const goToNextStep = useCallback(() => {
    setActiveStep((prev) => {
      if (prev < steps.length) {
        return prev + 1;
      }
      return prev;
    });
  }, [steps.length]);

  const goToPreviousStep = useCallback(() => {
    setActiveStep((prev) => {
      if (prev > 0) {
        return prev - 1;
      }
      return prev;
    });
  }, []);

  return (
    <StepperContext.Provider
      value={{
        goToNextStep,
        goToPreviousStep,
      }}
    >
      <>
        <IF condition={width > breakpointMedium}>
          <S.StepperWrapperHorizontal>
            <StepperComponent activeStep={activeStep} alternativeLabel>
              {steps.map((step, index) => (
                <Step key={index}>
                  <StepLabel>{step.title}</StepLabel>
                </Step>
              ))}
            </StepperComponent>

            <div>
              <div>{steps[activeStep].content}</div>
            </div>
          </S.StepperWrapperHorizontal>
        </IF>

        <IF condition={width < breakpointMedium}>
          <S.StepperWrapperVertical>
            <StepperComponent activeStep={activeStep} orientation="vertical">
              {steps.map((step) => (
                <Step key={step.title}>
                  <StepLabel>{step.title}</StepLabel>
                  <StepContent>{step.content}</StepContent>
                </Step>
              ))}
            </StepperComponent>
          </S.StepperWrapperVertical>
        </IF>
      </>
    </StepperContext.Provider>
  );
};

function useStepperContext() {
  const context = useContext(StepperContext);

  return context;
}

export { Stepper, useStepperContext };
